import { DownloadIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { ListFilter } from '@/pages/externals/pos-menu-masters/service';

type Props = {
  keyword: string;
  filter: ListFilter;
  shown: number;
  total: number;
  onKeyword: (value: string) => void;
  onFilter: (value: ListFilter) => void;
  onExport: () => void;
};

/** SCR009 No.10 のフィルターピル。排他選択です。 */
const pills: { key: ListFilter; label: string }[] = [
  { key: 'all', label: 'すべて' },
  { key: 'single', label: '単品' },
  { key: 'set', label: 'セット' },
  { key: 'hasChildren', label: '子商品あり' },
];

/** SCR009 No.9〜No.12 のツールバー。検索・絞り込み・件数・CSVエクスポート。 */
export const MenuMasterToolbar: React.FC<Props> = ({
  keyword,
  filter,
  shown,
  total,
  onKeyword,
  onFilter,
  onExport,
}) => (
  <Flex
    style={{ gap: '20px', marginBottom: '10px' }}
    align="center"
    wrap="wrap"
    data-testid="list-toolbar"
  >
    <InputGroup size="sm" maxW="320px">
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.500" data-testid="list-search-icon" />
      </InputLeftElement>
      <Input
        placeholder="POSメニューコード・商品名で検索"
        value={keyword}
        style={{ borderRadius: '4px' }}
        data-testid="list-search"
        onChange={(e) => onKeyword(e.target.value)}
      />
    </InputGroup>

    <Flex
      style={{ gap: '5px' }}
      wrap="wrap"
      data-testid="list-filter-pills"
      data-gap="5px"
    >
      {pills.map((pill) => (
        <Button
          key={pill.key}
          h="28px"
          px={3}
          fontSize="xs"
          style={{ fontWeight: 400 }}
          borderRadius="full"
          variant={filter === pill.key ? 'solid' : 'outline'}
          colorScheme={filter === pill.key ? 'darkBlue' : 'gray'}
          data-testid={`list-filter-${pill.key}`}
          onClick={() => onFilter(pill.key)}
        >
          {pill.label}
        </Button>
      ))}
    </Flex>

    <Text fontSize="sm" color="gray.600" ml="auto" data-testid="list-count">
      表示 {shown} / 全 {total} 件
    </Text>

    <Button
      size="sm"
      variant="outline"
      borderColor="gray.300"
      data-testid="list-csv-export"
      onClick={onExport}
      leftIcon={<DownloadIcon />}
      iconSpacing={2}
    >
      CSVエクスポート
    </Button>
  </Flex>
);
